module.exports = __webpack_public_path__ + "static/media/zenchess.96bad90c.jpeg";